import { Platform } from 'utils/platform';

import { TvAccountNotFoundModal } from './TvAccountNotFoundModal';
import { WebAccountNotFoundModal } from './WebAccountNotFoundModal';

export type AccountNotFoundModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const AccountNotFoundModal = (props: AccountNotFoundModalProps) => {
  if (Platform.isTV) {
    return <TvAccountNotFoundModal {...props} />;
  }

  return <WebAccountNotFoundModal {...props} />;
};
